import { Injectable } from '@angular/core';
import { DavesaMockApiService } from '@davesa/lib/mock-api';
import { econsentForms } from './data';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class EconsentMockApi {
    private _forms: any[] = econsentForms;

    /**
     * Constructor
     */
    constructor(private _davesaMockApiService: DavesaMockApiService) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {

        // -----------------------------------------------------------------------------------------------------
        // @ Update eConsent form - PUT
        // -----------------------------------------------------------------------------------------------------
        this._davesaMockApiService
            .onPut('api/econsent')
            .reply(({ request }) => {
                const id = request.body.id;
                const index = this._forms.findIndex(form => form.id === id);
                
                if (index === -1) {
                    return [404, { message: 'eConsent form not found' }];
                }

                const updatedForm = {
                    ...this._forms[index],
                    ...request.body,
                    updatedAt: request.body.updatedAt || new Date().toISOString()
                };
                this._forms[index] = updatedForm;
                return [200, cloneDeep(updatedForm)];
            });
        // -----------------------------------------------------------------------------------------------------
        // @ Get all eConsent forms - GET
        // -----------------------------------------------------------------------------------------------------
        this._davesaMockApiService
            .onGet('api/econsent')
            .reply(() => [200, cloneDeep(this._forms)]);

        // -----------------------------------------------------------------------------------------------------
        // @ Create new eConsent form - POST
        // -----------------------------------------------------------------------------------------------------
        this._davesaMockApiService
            .onPost('api/econsent')
            .reply(({ request }) => {
                const newForm = {
                    ...request.body,
                    id: (this._forms.length + 1).toString(),
                    createdAt: new Date().toISOString(),
                    updatedAt: new Date().toISOString(),
                    status: 'draft',
                    boldsignEditUrl: 'https://app.boldsign.com/document/embed/?templateId=516e0ebb-8b0d-4795-85a3-3d03c4b4ce79e_ZZ3XuX2O;1c42ba9b-4a92-4a1c-affd-18414b422f4b&isEditTemplate=true'
                };
                this._forms.unshift(newForm);
                return [200, cloneDeep(newForm)];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Delete eConsent form - DELETE
        // -----------------------------------------------------------------------------------------------------
        this._davesaMockApiService
            .onDelete('api/econsent/:id')
            .reply(({ request }) => {
                const id = request.params.get('id');
                const index = this._forms.findIndex(form => form.id === id);
                
                if (index === -1) {
                    return [404, { message: 'eConsent form not found' }];
                }

                this._forms.splice(index, 1);
                return [200, { message: 'eConsent form deleted successfully' }];
            });
    }
} 